import request from '../../utils/request';

export default {
    list: (params) => {
        return request({
            url: '/sourcing-product/search',
            method: 'post',
            data: params
        })
    },
    startTask: (params) => {
        return request({
            url: '/sourcing/task',
            method: 'put',
            params: params
        })
    },
    nextTask: (params) => {
        return request({
            url: '/sourcing/nextTask',
            method: 'post',
            data: params
        })
    },
    sendSourcingMail: (params) => {
        return request({
            url: '/sourcing-product/sendSourcingMail',
            method: 'post',
            data: params
        })
    },
    detail: (params) => {
        return request({
            url: `/sourcing-product/${params}`,
            method: 'get',
        })
    },
}
